import gql from 'graphql-tag';
export const sidebarDataQuery = gql `
  query sidebarDataQuery($accountId: Int!) {
    isAuthenticatedV2
    account(id: $accountId) {
      id
      name
      plan {
        amount
        hasMeteredBilling
        name
        id
        tiers {
          numTasks
          pricePerTask
        }
      }
      usage {
        periodEnd
        tasks {
          limit
          total
        }
        zaps {
          limit
          on
        }
      }
    }
  }
`;
const useSidebarData = ({ accountId, useQuery }) => {
    const variables = {
        accountId,
    };
    const result = useQuery(sidebarDataQuery, { ssr: false, variables });
    return result;
};
export default useSidebarData;
//# sourceMappingURL=useSidebarData.js.map
// @zapier/universal-layout@5.12.61 (4902ab0c1)
